import React from "react"
import classes from "./favours.module.scss"
import SectionTitle from "../../components/UI/sectionTitle/sectionTitle"
import { Element } from "react-scroll"
const favours = () => {
  return (
    <Element name="favours">
      <section>
        <SectionTitle titleType="Dark">Atliekamos Paslaugos</SectionTitle>
        <div className={classes.container}>
          {/* 
        <div className={classes.consult}>
          <h2 className={classes.title}>Konsultuoju</h2>
          <ul className={classes.listType}>
            <li>Nuo ko pradėti</li>
            <li>Kaip IT Gali padėti jums</li>
            <li>Kokio Sprendimo jums reikia</li>
            <li>Kaip pigiau</li>
          </ul>
        </div>
        <h2 className={classes.title}>Kuriu svetaines</h2>
        <div className={classes.themes}>
          <p>Naudojant Wordpreso šablonus</p>
          <p>
            Svetainė bus sukurta naudojant vieną iš padarytu šablonų. Pakeisiu
            tekstą pagal pageidavimus.Paleisiu svetainę, patikrinsiu dėl saugumo
            spragų. Bei apmokysiu klientą kaip keistį teksto turinį.
          </p>
        </div>
         */}
          <div className={classes.flexGrid}>
            <div className={classes.col}>
              <p>Iš wordpreso šablono</p>
              <ul>
                <li>Pagal šabloną</li>
                <li>Gatsby</li>
                <li>html/css</li>
                <li>Javascript</li>
              </ul>
            </div>
            <div className={classes.col}>
              <p>Custom wordpresinė</p>
              <ul>
                <li>Dizaino parinkimas</li>
                <li>UX Sprendimai</li>
                <li>Kokio Sprendimo jums reikia</li>
                <li>Kaip pigiau</li>
              </ul>
            </div>
            <div className={classes.col}>
              <p> Moderni</p>
              <ul>
                <li>Talpiname į serverius</li>
                <li>Optimizuoju svetaines</li>
                <li>Pagerinu SEO</li>
                <li>Svetainės palaikymas</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </Element>
  )
}

export default favours

/*  
1) Konsultuoju.
2) Kuriu priziuriu svetaines
3) Dizainas
4) Talpinu. 

Visos man sukurtos svetainės turi turinio valdymo.

1) Pagal jau sukurtą šabloną
    Pagal pateiktą wordpreso 'theme' šabloną. Sukuriu svetainę. 
    Klientas pateikią wordpreso svetainės šabloną. Aš pritaikau pagal kliento pageidavimus.
    Klientas naudodamasis wordpresu gali sąvarankiškai keisti svetainės turinį

2) Tradicinė nuo nulio wordpresinė su php svetainė
   Sukuriu nuo nulio,

3) Moderni custom svetainė
    Naudodamas išmanias technologijas kaip Gatsby, sukuriu svetainę su



*/
